import { render } from "./personal-certer.vue?vue&type=template&id=4e88c886&scoped=true"
import script from "./personal-certer.vue?vue&type=script&lang=js"
export * from "./personal-certer.vue?vue&type=script&lang=js"

import "./personal-certer.vue?vue&type=style&index=0&id=4e88c886&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4e88c886"

export default script